// extracted by mini-css-extract-plugin
export default {"button":"commonButtonStyle_button__GKP48","buttonBlue":"commonButtonStyle_buttonBlue__oS3yn","priceButtonStyle":"commonButtonStyle_priceButtonStyle__fTnUD"};